import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "user-avatar",
  "use": "user-avatar-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 48\" id=\"user-avatar\">\n    <g fill-rule=\"evenodd\">\n        <circle cx=\"24\" cy=\"24\" r=\"24\" fill-opacity=\".05\" />\n        <g fill-rule=\"nonzero\">\n            <path fill-opacity=\".15\" d=\"M0 20v-2.5c0-2.752 4.5-5.001 10-5.001s10 2.25 10 5V20H0zM5 5C5 2.24 7.236.003 9.997.003c2.76 0 4.999 2.237 5 4.998 0 2.76-2.237 5-4.998 5S5 7.762 5 5z\" transform=\"translate(14 14)\" />\n        </g>\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol